import { apiFetch } from '@/lib/apiFetch';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export async function fetchSuppliers({ limit = 10, offset = 1, query = {}, sort = { nombre: 1 } } = {}) {
  const res = await apiFetch(`${API_BASE}/suppliers/filter`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ limit, offset, query, sort }),
  });
  if (!res.ok) throw new Error('No se pudo cargar la lista de proveedores');
  return res.json();
}

export async function createSupplier(payload) {
  const res = await apiFetch(`${API_BASE}/suppliers`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('No se pudo crear el proveedor');
  return res.json();
}

export async function updateSupplier(id, payload) {
  const res = await apiFetch(`${API_BASE}/suppliers/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error('No se pudo actualizar el proveedor');
  return res.json();
}

export async function deleteSupplier(id) {
  const res = await apiFetch(`${API_BASE}/suppliers/${id}`, {
    method: 'DELETE',
  });
  if (!res.ok) throw new Error('No se pudo eliminar el proveedor');
  return res.json();
}

export async function toggleSupplierStatus(id) {
  const res = await apiFetch(`${API_BASE}/suppliers/${id}/toggle-status`, {
    method: 'POST',
  });
  if (!res.ok) throw new Error('No se pudo cambiar el estado del proveedor');
  return res.json();
}
